.root {
  &[data-variant='fancy'] {
    border: 4px solid transparent;
    background:
      linear-gradient(180deg, var(--mantine-primary-color-5), var(--mantine-primary-color-6)) padding-box,
      /* Inner background color */ linear-gradient(0deg, var(--mantine-primary-color-5), var(--mantine-primary-color-6))
        border-box; /* Gradient for border */
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.15);
    &:active {
      background:
        linear-gradient(0deg, var(--mantine-primary-color-5), var(--mantine-primary-color-6)) padding-box,
        linear-gradient(180deg, var(--mantine-primary-color-5), var(--mantine-primary-color-6)) border-box;
    }
    &:hover:not(:active) {
      background:
        linear-gradient(180deg, var(--mantine-primary-color-4), var(--mantine-primary-color-5)) padding-box,
        linear-gradient(0deg, var(--mantine-primary-color-4), var(--mantine-primary-color-5)) border-box;
    }
  }

  &[data-variant='fancy-active'] {
    border: 4px solid transparent;
    background:
      linear-gradient(180deg, var(--mantine-color-orange-6), var(--mantine-color-orange-8)) padding-box,
      /* Inner background color */ linear-gradient(0deg, var(--mantine-color-orange-6), var(--mantine-color-orange-8))
        border-box; /* Gradient for border */
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.2);
    &:active {
      background:
        linear-gradient(0deg, var(--mantine-color-orange-6), var(--mantine-color-orange-8)) padding-box,
        linear-gradient(180deg, var(--mantine-color-orange-6), var(--mantine-color-orange-8)) border-box;
    }
    &:hover:not(:active) {
      background:
        linear-gradient(180deg, var(--mantine-color-orange-5), var(--mantine-color-orange-7)) padding-box,
        linear-gradient(0deg, var(--mantine-color-orange-5), var(--mantine-color-orange-7)) border-box;
    }
  }
}
